/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import { withRouter } from 'react-router-dom'

import StartTabModal from '../../containers/tabs/StartTabModal'
import SidebarModal from '../SidebarModal'
import TabOrderItems from './TabOrderItems'
import Button from '../Button'

import styles from './TabsCartModal.module.scss'

const TabsCartModal = ({ onTopButtonTap, onBottomButtonTap, hasCartItems, isNewOrder, order, className, cartItems, onSelectItem, onRemove, total, itemCount }) => {
  const classNames = cn(styles.tabsCartModal, className)
  const [showStartTab, setShowStartTab] = useState(false)
  const [showCart, setShowCart] = useState(false)

  const tabText = isNewOrder ? "Start A Tab" : "Keep Tab Open"

  let payNowButton = (
    <Button key='pay now'
      onClick={onBottomButtonTap}
      disabled={!hasCartItems}
      className={[styles.actionButton, styles.mintGreenHighlight]}>
      Pay Now
    </Button>
  )

  if (!isNewOrder) {
    payNowButton = null
  }

  let buttons = [
    <Button key='topButton'
        onClick={() => isNewOrder ? setShowStartTab(true) : onTopButtonTap()}
        disabled={!hasCartItems}
        className={styles.actionButton}>
        {tabText}
    </Button>,
    payNowButton,
  ]

  const Cart = () => (
    <SidebarModal
      show={showCart}
      title='My Cart'
      className={styles.cart}
      onClose={() => setShowCart(false)}
    >
      <div className={styles.bodyContainer}>
        <TabOrderItems
          className={styles.itemsContainer}
          items={cartItems}
          onSelectItem={(item, index) => onSelectItem(index)}
          onRemove={onRemove}
        />
        <div className={styles.tabOrderTotals}>
          <div className={styles.row}>
            <span>Subtotal ({itemCount})</span>
            <span>{total}</span>
          </div>
        </div>
        <div className={styles.buttonContainer}>{buttons}</div>
      </div>
    </SidebarModal>
  )

  return (
    hasCartItems && (
      <div className={classNames}>
        <Button
          className={styles.showCartButton}
          onClick={() => setShowCart(true)}
        >
          <span className={styles.quantity}>{itemCount}</span>
          <span className={styles.title}>View Cart</span>
          <span className={styles.total}>{total}</span>
        </Button>
        <Cart />
        { showStartTab && <StartTabModal
          title={tabText}
          show={showStartTab}
          onClose={() => setShowStartTab(false)}
        /> }
      </div>
    )
  )
}

TabsCartModal.defaultProps = {
  onMount: () => {},
  onUnmount: () => {},
  onTopButtonTap: () => {},
  onBottomButtonTap: () => {},
  hasCartItems: false,
  isNewOrder: true,
  order: {},
}

TabsCartModal.propTypes = {
  onMount: PropTypes.func,
  onUnmount: PropTypes.func,
  onTopButtonTap: PropTypes.func,
  onBottomButtonTap: PropTypes.func,
  hasCartItems: PropTypes.bool,
  isNewOrder: PropTypes.bool,
  order: PropTypes.object,
}

export default withRouter(TabsCartModal)
